import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@volca/ui/components/ui/table";
import { Text } from "@volca/ui/components/ui/text";

// Illustrative figures only. This preview never reads customer report data.
const departments = [
  {
    name: "HVAC service",
    revenue: "$84,000",
    profit: "$46,200",
    margin: "55.0%",
  },
  {
    name: "HVAC install",
    revenue: "$96,000",
    profit: "$38,400",
    margin: "40.0%",
  },
  { name: "Plumbing", revenue: "$68,600", profit: "$34,728", margin: "50.6%" },
];

export const ProfitabilityReportPreview = () => (
  <figure
    aria-label="Example profitability report with illustrative data"
    className="w-full min-w-0"
  >
    <Card size="sm" className="gap-0 py-0">
      <CardHeader className="border-b border-line py-4">
        <CardTitle>August</CardTitle>
        <CardDescription>Sample monthly report</CardDescription>
      </CardHeader>
      <CardContent className="py-4">
        <dl className="grid grid-cols-3 gap-4">
          <Stack align="start" gap={1}>
            <dt>
              <Text variant="caption" tone="muted">
                Revenue
              </Text>
            </dt>
            <dd className="text-base leading-5 font-medium tabular-nums">
              $248,600
            </dd>
          </Stack>
          <Stack align="start" gap={1}>
            <dt>
              <Text variant="caption" tone="muted">
                Gross profit
              </Text>
            </dt>
            <dd className="text-base leading-5 font-medium tabular-nums">
              $119,328
            </dd>
          </Stack>
          <Stack align="start" gap={1}>
            <dt>
              <Text variant="caption" tone="muted">
                Gross margin
              </Text>
            </dt>
            <dd className="text-base leading-5 font-medium text-brand tabular-nums">
              48.0%
            </dd>
          </Stack>
        </dl>
        <Table className="mt-4 tabular-nums">
          <TableCaption className="sr-only">
            Example revenue, gross profit, and margin by department
          </TableCaption>
          <TableHeader>
            <TableRow className="hover:bg-transparent">
              <TableHead scope="col">Department</TableHead>
              <TableHead scope="col" className="text-right">
                Revenue
              </TableHead>
              <TableHead scope="col" className="text-right">
                Gross profit
              </TableHead>
              <TableHead scope="col" className="text-right">
                Margin
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {departments.map((department) => (
              <TableRow key={department.name} className="hover:bg-transparent">
                <TableHead scope="row" className="font-medium">
                  {department.name}
                </TableHead>
                <TableCell className="text-right text-subtle">
                  {department.revenue}
                </TableCell>
                <TableCell className="text-right">
                  {department.profit}
                </TableCell>
                <TableCell className="text-right font-medium">
                  {department.margin}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Text className="mt-4 text-pretty">
          Ask which department has the strongest margin, or compare this month
          with the last.
        </Text>
        <figcaption className="mt-4 border-t border-line pt-3 text-xs leading-4 text-subtle">
          Illustrative data. Your report is configured for your business.
        </figcaption>
      </CardContent>
    </Card>
  </figure>
);
